export const standardCode =
`
  <StandardNotification title="New IP Request.">
    Your request to add was submitted.
  </StandardNotification>
`;

export const standardWithIconCode =
`
  <StandardNotification
    title="Informative Title"
    withIcon={{ name: 'bank-checkmark', type: '40' }}
  >
    Lorem ipsum dolor sit amet, cons ectetur adipiscing elit, sed do eius mod tempor sed do eius .
  </StandardNotification>
`;

export const inlineCode =
`
  <InlineNotification title="Informative Title">
    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. 
  </InlineNotification>
`;

export const featuredActionCode =
`
  <ActionNotification
    highlightedTitle="Please Validate"
    title="your connections inventory"
    actionName="Validate"
    onActionClick={() => console.log('action notification callback')}
  >
    Expires on 13/12/2018
  </ActionNotification>
`;


// WEBPACK FOOTER //
// ./src/containers/components/Notification/constants/notificationsCode.js